import { map } from 'rxjs';
import { Component, Input, OnInit, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { NgFor } from '@angular/common';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'app-map-type01',
    standalone: true,
    imports: [RouterModule, GoogleMapsModule, NgFor],
    templateUrl: './map-type01.component.html',
    styleUrl: './map-type01.component.scss',
})
export class MapType01Component implements OnInit, OnChanges {
    @Input('size') size: string = 'lg';
    @Input('zoom') zoom: number = 6;
    @Input('disableUI') disableUI: boolean = false;

    @Input() locations: any[] = [];
    @Input() defaultLat: number = 0;
    @Input() defaultLng: number = 0;
    @Input() bounds: { south: number; west: number; north: number; east: number } | null = null;

    @ViewChild(GoogleMap) googleMap!: GoogleMap;

    public view: any = {
        // nearbyLocations: [],
        searchQuery: '',
        size: 'lg',
 
        map: {
            // zoom: 6,
            // maxZoom: 20,
            zoom: 10,
            maxZoom: 15,
            disableUI: true,
            style: [
                {
                    stylers: [
                        {
                            hue: '#ffb718',
                        },
                        {
                            saturation: 50,
                        },
                    ],
                },
                {
                    featureType: 'water',
                    stylers: [
                        {
                            color: '#f1f5f9',
                            //"color": "#ffffff"
                        },
                    ],
                },
                {
                    featureType: 'administrative.country',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
            ],
        },
    };
    public userLocation: { lat: number; lng: number } | null = null;
    center = { lat: this.defaultLat, lng: this.defaultLng };

    constructor() {}
    //   ngOnChanges(changes: SimpleChanges): void {
    //     if (changes.locations && this.locations.length) {
    //       this.center = { lat: this.locations[0].lat, lng: this.locations[0].lng };
    //     }
    //   }

    ngOnInit(): void {
        this.view.size = this.size;
        this.locations.forEach((l) => {
            l.lat = Number(l.lat);
            if (l.lng === undefined) {
                l.lng = l.long;
            }
            l.lng = Number(l.lng);
        });
        this.view.locations = this.locations;

        this.view.map.zoom = this.zoom;
        this.view.map.disableUI = this.disableUI;
        //this.requestUserLocation();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['bounds'] && this.bounds) {
            setTimeout(() => this.applyBounds(), 0);
        }
    }

    private applyBounds(): void {
        if (!this.bounds || !this.googleMap) return;
        const b = new google.maps.LatLngBounds(
            { lat: this.bounds.south, lng: this.bounds.west },
            { lat: this.bounds.north, lng: this.bounds.east }
        );
        this.googleMap.fitBounds(b);
    }
    zoomToLocation(location: any, zoomLevel: number) {
        this.center = { lat: location.lat, lng: location.lng };
        this.view.map.zoom = zoomLevel;
    }
    requestUserLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.userLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    this.filterNearbyLocations(event);
                },
                (error) => {
                    console.error('Error getting location', error);
                    // Handle error or fallback
                }
            );
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    }
    // filterNearbyLocations() {
    // const maxDistance = 50000; // Max distance in meters (50 km in this example)
    // this.view.nearbyLocations = this.view.locations.filter((location) =>
    //   this.calculateDistance(this.userLocation, location) <= maxDistance
    // );
    // }
    filterNearbyLocations(event: Event) {
        const searchQuery = (
            event.target as HTMLInputElement
        ).value.toLowerCase();
        this.view.filteredLocations = this.view.nearbyLocations.filter(
            (location) => location.title.toLowerCase().includes(searchQuery)
        );
    }
    // filterNearbyLocations() {
    //     if (this.view.searchQuery) {
    //     // Filter by search query
    //     const query = this.view.searchQuery.toLowerCase();
    //     this.view.filteredLocations = this.view.locations.filter(location =>
    //         location.title.toLowerCase().includes(query)
    //     );
    //     } else if (this.userLocation) {
    //     // Filter by nearby locations based on user location
    //     const nearbyRadius = 50; // Distance in kilometers
    //     this.view.filteredLocations = this.view.locations.filter(location =>
    //         this.calculateDistance(
    //         this.userLocation!.lat,
    //         this.userLocation!.lng,
    //         location.lat,
    //         location.lng
    //         ) <= nearbyRadius
    //     );
    //     } else {
    //     // Show all locations if no filter is applied
    //     this.view.filteredLocations = this.view.locations;
    //     }
    // }
    calculateDistance(
        lat1: number,
        lng1: number,
        lat2: number,
        lng2: number
    ): number {
        const R = 6371; // Earth's radius in km
        const dLat = this.deg2rad(lat2 - lat1);
        const dLng = this.deg2rad(lng2 - lng1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) *
                Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLng / 2) *
                Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // Distance in km
    }

    deg2rad(deg: number): number {
        return deg * (Math.PI / 180);
    }
}
